import {
  faDesktop,
  faFlask,
  faFlaskVial,
  faHouseMedical,
  faKitMedical,
  faSignalStream,
  faSyringe,
  faUserMd,
  faWavePulse,
} from '@fortawesome/pro-light-svg-icons';
import type { IconDefinition } from '@fortawesome/pro-light-svg-icons';

import { SearchResult } from '@/app/(main)/_components/search-modal/search-modal.types';
import { SearchType } from '@/types/most-search-type';
import { pluralize } from '@/utils/pluralize.util';

const TITLE_MAP: Record<string, string> = {
  PRESENTIAL_CONSULTATION: 'Atendimento presencial',
  ONLINE_CONSULTATION: 'Teleconsulta',
  IMAGE_EXAM: 'Exame de imagem',
  EMERGENCY: 'Pronto atendimento',
  SURGERY: 'Cirurgia',
};

const ICON_MAP: Record<string, IconDefinition> = {
  PRESENTIAL_CONSULTATION: faUserMd,
  ONLINE_CONSULTATION: faDesktop,
  LABORATORIAL_EXAM: faFlask,
  IMAGE_EXAM: faSignalStream,
  EMERGENCY: faKitMedical,
  VACCINE: faSyringe,
  SURGERY: faWavePulse,
  CLINIC: faHouseMedical,
  BRANCH_LABORATORY: faFlaskVial,
  DOCTOR: faUserMd,
};

function getItemsCount(id?: string) {
  return id?.split(',').length;
}

function resolveExamOrVaccine(
  label: string,
  singular: string,
  plural: string,
  id?: string,
  inRecentSearch?: boolean,
) {
  if (!inRecentSearch) {
    return label;
  }

  const count = getItemsCount(id);

  const parts = [
    label,
    pluralize(count, singular, plural),
  ].filter(Boolean);

  return parts.join(' - ');
}

export function resolveTitle(searchResult: SearchResult, inRecentSearch = false): string {
  const { searchType, id, specialties, city, state } = searchResult;

  if (searchType && TITLE_MAP[searchType]) {
    return TITLE_MAP[searchType];
  }

  if (searchType === SearchType.LABORATORIAL_EXAM) {
    return resolveExamOrVaccine(
      'Exame laboratorial',
      'exame',
      'exames',
      id,
      inRecentSearch,
    );
  }

  if (searchType === SearchType.VACCINE) {
    return resolveExamOrVaccine(
      'Vacina',
      'vacina',
      'vacinas',
      id,
      inRecentSearch,
    );
  }

  if (searchType === SearchType.DOCTOR) {
    const specialtiesLabel = specialties?.slice(0, 2).join(', ');
    return ['Profissional', specialtiesLabel].filter(Boolean).join(' - ');
  }

  if (searchType === SearchType.CLINIC) {
    return ['Local de atendimento', city, state].filter(Boolean).join(' - ');
  }

  if (searchType === SearchType.BRANCH_LABORATORY) {
    return ['Laboratório', city, state].filter(Boolean).join(' - ');
  }

  return '';
}

export function resolveIcon(searchResult: SearchResult): IconDefinition {
  return ICON_MAP[searchResult.searchType] ?? faUserMd;
}
